/* Bundle containers require a selection in their builder before cart insertion.
   Scoped to the two container variants; does not touch a completed builder's API add. */
(() => {
  'use strict';
  // The builder owns the selection form and its completed submission.
  if (/\/pages\/(?:3|5)-pieces-bundle\/?$/.test(location.pathname)) return;
  const bundles = [
    { handle: 'choose-your-3-jewelry-pieces', variant: '67727863185773', count: 3 },
    { handle: 'choose-your-5-jewelry-pieces', variant: '67727863153005', count: 5 }
  ];
  const destination = (b) => `/pages/${b.count}-pieces-bundle#bundle-picker`;
  const byPath = (value) => {
    try { const u = new URL(value, location.origin); return u.origin === location.origin && bundles.find(b => u.pathname.replace(/\/$/, '').endsWith(`/products/${b.handle}`)); }
    catch { return null; }
  };
  const entryBundle = byPath(location.href);
  if (entryBundle) { location.replace(destination(entryBundle)); return; }
  const byForm = (form) => {
    const value = form?.querySelector('input[name="id"]')?.value;
    return bundles.find(b => b.variant === String(value));
  };
  const byControl = (control) => {
    const explicit = control.getAttribute('data-iso-add') || control.getAttribute('data-variant-id');
    const direct = bundles.find(b => b.variant === String(explicit));
    if (direct) return direct;
    const formBundle = byForm(control.form || control.closest('form'));
    if (formBundle) return formBundle;
    // Sticky add buttons are outside their product form.
    if (control.closest('sticky-add-to-cart') && byPath(location.href)) return byPath(location.href);
    return null;
  };
  function refresh(root = document) {
    root.querySelectorAll('a[href]').forEach(a => {
      const b = a.getAttribute('href')?.startsWith('#') ? null : byPath(a.href);
      if (b) a.href = destination(b);
    });
    root.querySelectorAll('button').forEach(button => {
      // Quantity controls must retain their own behavior.
      if (button.name === 'minus' || button.name === 'plus') return;
      if (!(button.matches('[name="add"], [data-iso-add], .add-to-cart-button') || button.closest('sticky-add-to-cart'))) return;
      const b = byControl(button);
      if (b && button.dataset.ecBundleEntry !== String(b.count)) {
        button.dataset.ecBundleEntry = String(b.count);
        button.textContent = `Choose ${b.count} pieces`;
        button.setAttribute('aria-label', `Choose your ${b.count} jewellery pieces`);
      }
    });
  }
  window.addEventListener('click', event => {
    const control = event.target.closest?.('button, a');
    if (!control) return;
    let b = control.tagName === 'A' ? byPath(control.href) : null;
    if (control.tagName === 'BUTTON' && (control.matches('[name="add"], [data-iso-add], .add-to-cart-button') || control.closest('sticky-add-to-cart'))) b = byControl(control);
    if (!b) return;
    event.preventDefault(); event.stopImmediatePropagation();
    location.assign(destination(b));
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\?|$)/.test(form.action)) return;
    const b = byForm(form);
    if (!b) return;
    event.preventDefault(); event.stopImmediatePropagation();
    location.assign(destination(b));
  }, true);
  refresh();
  let queued = false;
  new MutationObserver((records) => {
    if (!records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1))) return;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
